import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import {
  FormsModule,
  ReactiveFormsModule,
} from '@angular/forms';
import { RouterModule } from '@angular/router';
import { ButtonComponent } from './components/button/button.component';
import { BulletItemComponent } from './components/bullet-item/bullet-item.component';
import { SimpleModalComponent } from './components/simple-modal/simple-modal.component';
import { SvgIconComponent } from './components/svg-icon/svg-icon.component';
import { SomethingWentWrongModalComponent } from './components/something-went-wrong-modal/something-went-wrong-modal.component';


@NgModule({
  imports: [
    CommonModule,
    ReactiveFormsModule,
    FormsModule,
    RouterModule,
  ],
  declarations: [
    SimpleModalComponent,
    ButtonComponent,
    BulletItemComponent,
    SvgIconComponent,
    SomethingWentWrongModalComponent
  ],
  exports: [
    SimpleModalComponent,
    ButtonComponent,
    BulletItemComponent,
    SvgIconComponent,
    SomethingWentWrongModalComponent
  ],
})

export class SharedModule { }
